import { render } from "./TestDetailTable.vue?vue&type=template&id=23e5cb02&scoped=true"
import script from "./TestDetailTable.vue?vue&type=script&lang=js"
export * from "./TestDetailTable.vue?vue&type=script&lang=js"

import "./TestDetailTable.vue?vue&type=style&index=0&id=23e5cb02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e5cb02"]])

export default __exports__